import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WeatherModule from "@/components/WeatherModule";
import RadarScanner from "@/components/RadarScanner";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CloudSun, Calendar, MapPin } from "lucide-react";
import weatherHero from "@/assets/weather-hero.jpg";
import weatherVarious from "@/assets/weather-various.webp";
import radarSkyBg from "@/assets/radar-sky-bg.jpg";
import radarSkyVideo from "@/assets/radar-sky-bg.mp4.asset.json";
import weatherVariousVideo from "@/assets/weather-various.mp4.asset.json";
const Weather = () => {
  return <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `url(${weatherHero})`
        }}>
            <div className="absolute inset-0 bg-gradient-to-b from-background/55 via-background/45 to-background/65" />
          </div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center space-y-6">
              <span className="text-primary text-sm font-semibold tracking-wider uppercase">
                Plan Your Journey
              </span>
              <h1 className="text-5xl md:text-6xl font-serif font-bold text-foreground">
                Real-Time Weather Conditions
              </h1>
              <p className="text-xl text-foreground leading-relaxed max-w-3xl mx-auto bg-background/80 backdrop-blur-sm px-8 py-4 rounded-lg border border-primary/20 shadow-lg">
                Stay informed about current weather conditions to ensure the smoothest, most comfortable ride experience possible.
              </p>
            </div>
          </div>
        </section>

        {/* Radar Scanner Section */}
        <section className="relative py-16 overflow-hidden">
          <video
            className="absolute inset-0 w-full h-full object-cover"
            src={radarSkyVideo.url}
            poster={radarSkyBg}
            autoPlay
            loop
            muted
            playsInline
            aria-hidden="true"
          />
          <div
            className="absolute inset-0 bg-gradient-to-b from-background/45 via-background/30 to-background/55"
            aria-hidden="true"
          />
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center mb-8">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground drop-shadow-lg">
                Live Weather Radar
              </h2>
              <p className="text-foreground/90 mt-2">
                Real-time weather monitoring for your journey
              </p>
            </div>
            <RadarScanner />
          </div>
        </section>

        {/* Weather Module Section */}
        <section className="py-16 luxury-gradient">
          <div className="container mx-auto px-4">
            <WeatherModule />
          </div>
        </section>

        {/* Weather Benefits Section */}
        <section className="relative py-20 bg-secondary overflow-hidden">
          <video
            className="absolute inset-0 w-full h-full object-cover opacity-40"
            src={weatherVariousVideo.url}
            poster={weatherVarious}
            autoPlay
            loop
            muted
            playsInline
            aria-hidden="true"
          />
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center mb-16">
              <span className="text-primary text-sm font-semibold tracking-wider uppercase">
                Weather-Aware Service
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 text-foreground">
                We Monitor Conditions For You
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
              <div className="text-center space-y-4">
                <div className="flex justify-center text-primary">
                  <CloudSun className="w-12 h-12" />
                </div>
                <h3 className="text-xl font-semibold text-foreground">Real-Time Updates</h3>
                <p className="text-muted-foreground">
                  Live weather data refreshes every 5 minutes to keep you informed
                </p>
              </div>

              <div className="text-center space-y-4">
                <div className="flex justify-center text-primary">
                  <Calendar className="w-12 h-12" />
                </div>
                <h3 className="text-xl font-semibold text-foreground">7-Day Forecast</h3>
                <p className="text-muted-foreground">
                  Plan ahead with accurate extended forecasts for your upcoming trips
                </p>
              </div>

              <div className="text-center space-y-4">
                <div className="flex justify-center text-primary">
                  <MapPin className="w-12 h-12" />
                </div>
                <h3 className="text-xl font-semibold text-foreground">Live Radar</h3>
                <p className="text-muted-foreground">
                  Interactive radar shows precipitation patterns in real-time
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <Card className="card-luxury bg-gradient-to-r from-card to-secondary">
              <CardContent className="p-12 text-center space-y-6">
                <h2 className="text-4xl font-serif font-bold text-foreground">
                  Ready for a Smooth Ride?
                </h2>
                <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
                  Book now and let us handle the weather—you just enjoy the journey.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  
                  <Button asChild variant="outline" className="text-lg px-8 py-6 border-primary text-primary hover:bg-primary hover:text-primary-foreground">
                    <a href="tel:210-296-7409">Call Us Now</a>
                  </Button>
                  <Button asChild className="text-lg px-8 py-6 bg-blue-400 hover:bg-blue-500 text-white">
                    <a href="sms:210-296-7409">Text us Now</a>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </main>
      <Footer />
    </div>;
};
export default Weather;